import Debug from 'debug';
import { injectable, inject } from 'inversify';
import { reportNonFatalError } from '@/app/error-handling';
import { QueryHandler } from '@/app/tracking/common';
import { QueryStudentInfoTrackingQuery, QueryStudentInfoTrackingQueryPayload } from '../api';
import { StudentInfoDataStoreSymbol, StudentInfoDataStore } from './student-info-data-store'
import { defaultStudentInfo } from '../api/student-info';

const debug = Debug('query-student-info-tracking-query-handler');

@injectable()
export class QueryStudentInfoTrackingQueryHandler implements QueryHandler<QueryStudentInfoTrackingQuery> {
 
  constructor(
    @inject(StudentInfoDataStoreSymbol)
    private store: StudentInfoDataStore) {
  }

  public async execute(_payload: QueryStudentInfoTrackingQueryPayload) {

    debug('loading student info')
    const loadResult = await this.store.get()
    debug('student info result', loadResult)
    if (!loadResult.success) {
      // we have nonrecoverable error
      reportNonFatalError(loadResult.error.code, loadResult.error.details)
      return { studentInfo: defaultStudentInfo() }
    }

    return  {
      studentInfo: loadResult.value
    }
  }
}
